import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getShopifyStatus({ payload: { signal, onSuccess, onError } = {} }) {
  try {
    const { data } = yield call(fetch, {
      api: api.shopify.status,
      signal
    });

    const preparedData = data?.result || data;

    onSuccess && onSuccess(preparedData);
    yield put(actions.getShopifyStatusDone(preparedData));
  } catch (error) {
    onError && onError(error);
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyStatusFailed,
      endpoint: api.shopify.status.url
    });
  }
}

export const getShopifyStatusSaga = takeEvery(types.GET_SHOPIFY_STATUS_REQUEST, getShopifyStatus);
